import script from "./team-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./team-list.vue?vue&type=script&lang=ts&setup=true"

import "./team-list.vue?vue&type=style&index=0&id=00352722&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00352722"]])

export default __exports__